import PageFooter from './PageFooter'

export default PageFooter



// WEBPACK FOOTER //
// ./src/components/shared/PageFooter/index.js